(function($){
    $(function(){
        var $pagedList = $('.zn-paged-service-list');
            
        if ($pagedList.length) {
            $pagedList.each(function(){
                var $this = $(this),
                    pageSize = $this.data('page-size'),
                    thisID = $this.attr('id'),
                    $list = $this.find('ul'),
                    list = new List(thisID, {
                        page: pageSize,
                        pagination: true
                    }),
                    totali = list.size(),
                    curPage = 1,
                    totalpages = Math.ceil(totali/pageSize);

                    $('<div class="zn-controls"><span class="zn-current">1</span><span class="zn-sep">/</span><span class="zn-total">'+ totalpages +'</span><button disabled aria-controls="'+thisID+'" aria-label="Previous Set of Services" class="zn-prev"></button><button aria-controls="'+thisID+'" aria-label="Next Set of Services" class="zn-next"></button></div>').appendTo($this);

                    var $paging = $this.find('.pagination'),
                        $nextBtn = $this.find('button.zn-next'),
                        $prevBtn = $this.find('button.zn-prev'),
                        $current = $this.find('.zn-current');

                    list.on('updated', function(){
                        $current.html(curPage);

                        if (curPage == totalpages) {
                            $nextBtn.attr('disabled', 'true');
                        } else {
                            $nextBtn.removeAttr('disabled');
                        }

                        if (curPage == 1) {
                            $prevBtn.attr('disabled', 'true');
                        } else {
                            $prevBtn.removeAttr('disabled');
                        }
                    });

                    $nextBtn.on('click', function(){
                        curPage = curPage+1;
                        $paging.find('.active').next().trigger('click');

                    });

                    $prevBtn.on('click', function(){
                        curPage = curPage-1;
                        $paging.find('.active').prev().trigger('click');
                    });

                    
            });
        }
    });
})($JQ);